import { render, staticRenderFns } from "./ChangeBlockStorage.vue?vue&type=template&id=03f68932&"
import script from "./ChangeBlockStorage.vue?vue&type=script&lang=js&"
export * from "./ChangeBlockStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports